<div class="retask-options-dialog" [class.retask-options-dialog--dark]="data.darkTheme">
  <h2 mat-dialog-title>Select a Re-Task Option</h2>

  <div class="dialog-body">

    <div class="retask-options-dialog__meta" *ngIf="data.taskName || data.sensorName">
      <span *ngIf="data.taskName">Task: {{ data.taskName }}</span>
    </div>

    <div
      class="option"
      [class.selected]="selectedMode === 'existing-sensor'"
      (click)="selectMode('existing-sensor')"
    >
      <div class="option-left">
        <div class="label-block">
          <div class="title">Use the Existing Sensor(s)</div>
          <div class="subtitle">
            Continue with the current sensor(s) and task settings, only changing the time of interest (TOI).
          </div>
        </div>
      </div>
      <mat-radio-button
        color="primary"
        [checked]="selectedMode === 'existing-sensor'"
      ></mat-radio-button>
    </div>

    <div
      class="option"
      [class.selected]="selectedMode === 'different-sensors'"
      (click)="selectMode('different-sensors')"
    >
      <div class="option-left">
        <div class="label-block">
          <div class="title">Choose Different Sensor(s)</div>
          <div class="subtitle">
            Change the TOI and choose different sensor(s) in the Sensor-Cost section.
          </div>
        </div>
      </div>
      <mat-radio-button
        color="primary"
        [checked]="selectedMode === 'different-sensors'"
      ></mat-radio-button>
    </div>
  </div>

  <div mat-dialog-actions align="center" class="btns">
    <button mat-stroked-button type="button" (click)="cancel()" class="custom-button">Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="continue()">Continue</button>
  </div>
</div>